import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as RamSvg } from './ram.svg';
import { FC } from 'react';

const RamIcon: FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon
            component={RamSvg}
            inheritViewBox
            sx={{
                path: {
                    fill: 'currentColor',
                },
            }}
            {...props}
        />
    );
};

export default RamIcon;
